import React, { Component } from 'react'
import './question-bank.scss'
import SessionCache from '../routes/session-cache'
import SchoolApi from '../../apis/school'
import { getImageSource } from '../../utility/image-source'
import { Constants, ImageConstants } from '../../constants/constants'
import Path from '../routes/routes-path'
import QuestionList from './question-list/question-list'
import { Modal, ModalBody } from 'reactstrap'
import ReactTooltip from 'react-tooltip';
import Dropdown from '../common/dropdown/dropdown'
import MasterDataApi from '../../apis/master-data'
import CWCustomCKEditor from '../common/cw-custom-ck-editor/cw-custom-ck-editor'
import CommonUtils from '../../utility/common-utilities'
import QuestionSetApi from '../../apis/question-set'
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component'
import AddQuestion from './add-question/add-question'

const QUESTION_TYPES = [
  {
    title: 'SINGLE STEP',
    value: 1
  },
  {
    title: 'MULTI STEP',
    value: 2
  }
]
const QUESTION_SELECT_TYPES = [
  {
    title: 'SINGLE SELECT',
    value: 1
  },
  {
    title: 'MULTI SELECT',
    value: 2
  }
]
const OPTIONS = [
  {
    isCorrect: false,
    content: ''
  },
  {
    isCorrect: false,
    content: ''
  },
  {
    isCorrect: false,
    content: ''
  },
  {
    isCorrect: false,
    content: ''
  }
]
const DEFAULT_STEP_VALUE = {
  content: '',
  options: OPTIONS,
  questionSelectType: QUESTION_SELECT_TYPES[0]
}
class QuestionBank extends Component {
  state = {
    activeTabIndex: 0,
    classes: [],
    chapterList: [],
    showAddQuestion: false,
    options: OPTIONS,
    content: '',
    questionSelectType: QUESTION_SELECT_TYPES[0],
    questionType: QUESTION_TYPES[0],
    steps: [DEFAULT_STEP_VALUE],
    complexityList: [],
    complexity: ''
  }

  accessRights = SessionCache.getAllowedModule()
  user = SessionCache.getUser()

  constructor (props) {
    super(props)
    this.getClasses()
    this.getPracticeQuestionComplexity()
  }

  getClasses = () => {
    SchoolApi.getClassAndBoard({})
      .then(school => {
        let classes = [],
          boards = []
        for (let i = 0; i < school.classes.length; i++) {
          classes.push({
            title: school.classes[i].name,
            value: school.classes[i].name
          })
        }

        for (let i = 0; i < school.boards.length; i++) {
          boards.push({
            title: school.boards[i].name,
            value: school.boards[i].name
          })
        }

        this.setState(
          {
            classes: classes,
            boards: boards,
            selectedTabName: classes[0].title
          },
          _ => {
            this.getChapterList(this.state.selectedTabName)
          }
        )
      })
      .catch(err => {})
  }

  getPracticeQuestionComplexity = _ => {
    QuestionSetApi.getPracticeQuestionComplexity({})
      .then(response => {
        const complexityList = []
        response.map(res => {
          if (res.title !== 'HOTS') {
            complexityList.push({
              value: res._id,
              title: res.title
            })
          }
        })
        this.setState({
          complexityList
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  onClickTab = (tabIdx, title) => {
    this.setState(
      {
        activeTabIndex: tabIdx,
        selectedTabName: title
      },
      _ => {
        this.questionListRef.getQuestionSet({})
      }
    )
  }

  addQuestionsSuccess = (isAdd, isError, errorCode) => {
    if (isAdd) {
      this.showToaster('info', 'Question added successfully')
    } else {
      this.showToaster('info', 'Question updated successfully')
    }
    if (isError && errorCode === 11000) {
      this.showToaster('info', 'Question set already added for chapter')
    }
    if (this.questionListRef) this.questionListRef.getQuestionSet({})
    this.setState({
      showAddQuestion: false,
      selectedQuestion: null
    })
  }

  getTabs = () => {
    const {
      classes,
      search,
      complexityList,
      complexity,
      chapterList,
      chapterFilter
    } = this.state
    return (
      <div className='tab-container'>
        <div className='tab-inner-container'>
          {classes.map((tab, index) => (
            <div
              key={'tab' + index}
              className={`tab mr-3 ${
                this.state.activeTabIndex == index ? 'tab-active' : ''
              }`}
              onClick={() => this.onClickTab(index, tab.title)}
            >
              <div className='tab-center'>
                <span>{tab.title}</span>
              </div>

              {this.state.activeTabIndex == index ? (
                <div className='active-cirlce'></div>
              ) : (
                ''
              )}
            </div>
          ))}
        </div>
        <div className='filter-container ml-2'>
          <div className='complexity chapter ml-2'>
            {chapterList?.length > 0 && (
              <Dropdown
                ref={el=> this.chapterDropdown = el}
                text='title'
                placeholder='Select Chapter'
                options={chapterList}
                onSelect={option =>
                  this.onSelectNormal(option, 'chapterFilter')
                }
                value={chapterFilter?.value}
              />
            )}
          </div>
          <div className='complexity ml-2'>
            {complexityList?.length > 0 && (
              <Dropdown
                ref={el=> this.complexityDropdown = el}
                text='title'
                placeholder='Select Complexity'
                options={complexityList}
                onSelect={option => this.onSelectNormal(option, 'complexity')}
                value={complexity?.value}
              />
            )}
          </div>
          <div className='search ml-2'>
            <div className=''>
              <input
                className={`search-input`}
                placeholder='Search'
                value={search}
                onChange={e => this.onSelectNormal(e.target?.value, 'search')}
              />
            </div>
            <div className='my-auto text-right'>
              <img
                className='search-icon cursor-pointer'
                src={getImageSource(ImageConstants.SEARCH)}
              />
            </div>
          </div>
          <div className='filter-buttons'>
            <button
              className={`cw-button-primary ml-2`}
              onClick={_ => this.onGoFilter(true)}
            >
              Go
            </button>
            <button
              className={`cw-btn-secondary ml-2`}
              onClick={_ => this.clearSearch()}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    )
  }

  openSelectChapter = _ => {
    this.setState({
      showSelectChapter: true,
      selectedClassName: '',
      chapter: ''
    })
  }

  hideSelectChapter = _ => {
    this.setState({
      showSelectChapter: false
    })
  }

  addOptions = _ => {
    const { options } = this.state
    options.push({ isCorrect: false, content: '' })
    this.setState({
      options
    })
  }

  removeOption = index => {
    const { options } = this.state
    options.splice(index)
    this.setState({
      options
    })
  }

  showAddStep = _ => {
    let { steps } = this.state
    this.setState({
      onlyStep: true,
      stepIndex: steps.length,
      content: '',
      options: [
        {
          isCorrect: false,
          content: ''
        },
        {
          isCorrect: false,
          content: ''
        },
        {
          isCorrect: false,
          content: ''
        },
        {
          isCorrect: false,
          content: ''
        }
      ],
      questionSelectType: QUESTION_SELECT_TYPES[0]
    })
  }

  onStepEdit = index => {
    const { steps } = this.state
    const step = steps[index]
    this.setState({
      onlyStep: true,
      stepIndex: index,
      content: step.content,
      options: step.options,
      questionSelectType: {
        title: step.typeName,
        value: step.type
      }
    })
  }

  removeStep = index => {
    const { steps } = this.state
    steps.splice(index, 1)
    this.setState({
      steps
    })
  }

  validateClassChapterPayload = _ => {
    let isInvalid = true
    if (!this.state.chapter) {
      this.setState({
        errorMessage: 'Please select chapter'
      })
      isInvalid = false
    }
    if (!this.state.selectedClassName) {
      this.setState({
        errorMessage: 'Please select class'
      })
      isInvalid = false
    }
    return isInvalid
  }

  openAddQuestion = isAdd => {
    if (!this.validateClassChapterPayload()) return
    this.setState(
      {
        showAddQuestion: true,
        showSelectChapter: false,
        errorMessage: ''
      },
      _ => {
        if (isAdd && this.addQuestionRef) {
          this.addQuestionRef.resetState()
        }
        if (this.tooltip) {
          this.tooltip.tooltipRef = null
          this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
      }
    )
  }

  hideAddQuestion = _ => {
    this.setState({
      showAddQuestion: false
    })
  }

  clearSearch = _ => {
    this.setState(
      {
        complexity: '',
        search: '',
        chapterFilter: ''
      },
      _ => {
        if(this.chapterDropdown) this.chapterDropdown.resetSelectText()
        if(this.complexityDropdown) this.complexityDropdown.resetSelectText()
        this.onGoFilter()
      }
    )
  }

  onGoFilter = _ => {
    const { search, complexity, chapterFilter } = this.state
    let payload = {}
    if (search) payload.searchText = search
    if (complexity) payload.complexityId = complexity?.value || ''
    if (chapterFilter) payload.chapterId = chapterFilter?.value
    this.filter = payload
    this.questionListRef.getQuestionSet(payload)
  }

  onPageSelected = page => {
    let payload = {}
    if(this.filter) payload = this.filter
    payload.page = page
    this.questionListRef.getQuestionSet(payload)
  }

  onSelectNormal = (option, key) => {
    let { steps } = this.state
    this.setState({ [key]: option }, _ => {
      if (key === 'selectedClassName') this.getChapterList(option)
      if (key === 'questionType') {
        if (option.value === 2) steps = []
        if (option.value === 1) steps = [DEFAULT_STEP_VALUE]
        this.setState({
          steps
        })
      }
      // if (key === 'complexity' || key === 'search') {
      //   const { search, complexity, chapterFilter } = this.state
      //   const payload = {}
      //   payload.searchText = search
      //   payload.complexityId = complexity?.value || ''
      //   this.questionListRef.setSearchData(payload)
      // }
      // if (key === 'chapterFilter') {
      //   const { chapterFilter } = this.state
      //   const payload = {}
      //   payload.chapterId = chapterFilter?.value
      //   this.questionListRef.getQuestionSet(payload)
      // }
    })
  }

  onSelectStep = (option, key, index) => {
    const { options } = this.state
    this.setState({ [key]: option }, _ => {
      if (key === 'questionSelectType') {
        options.forEach(opt => {
          opt.isCorrect = false
          return opt
        })
        this.setState({
          options
        })
      }
    })
  }

  getChapterList = className => {
    if (!className) return
    const payload = {
      class: className
    }
    MasterDataApi.getChapterList(payload)
      .then(response => {
        const chapterList = []
        if (response.data.chapters && response.data.chapters.length) {
          response.data.chapters.forEach(chapter => {
            chapterList.push({
              title: chapter.title,
              value: chapter.key
            })
          })
        }
        this.setState({
          chapterList
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  onPasteEvent = event => {
    if (event.data.dataValue.includes(Constants.CW_GLOSSARY)) {
      event.data.dataValue = ''
      return
    }

    if (event.data.dataValue.includes(Constants.CUSTOM_MATH_TAG)) {
      let parsedContent = CommonUtils.cwMathParsar(event)

      if (parsedContent) event.data.dataValue = parsedContent

      return
    }

    event.data.dataValue = CommonUtils.cleanHtmlOnPaste(
      event.data.dataValue,
      true
    )
  }

  onCorrectChange = (e, index) => {
    const { questionSelectType, options } = this.state
    if (questionSelectType?.value === 1) {
      options.forEach((option, idx) => {
        if (index !== idx) {
          option.isCorrect = false
        }
        return option
      })
    }
    options[index].isCorrect = !options[index].isCorrect
    this.setState({
      options
    })
  }

  onAnswerChange = (e, index) => {
    const { options } = this.state
    options[index].content = e.target.value
    this.setState({
      options
    })
  }

  validateStepPayload = payload => {
    let isInvalid = true
    if (!payload.content) {
      this.setState({
        errorMessage: 'Please enter question'
      })
      isInvalid = false
    }
    if (!payload.type || !payload.typeName) {
      this.setState({
        errorMessage: 'Please select question type'
      })
      isInvalid = false
    }
    let numberOfAnswer = 0
    let correctAnswer = 0
    payload.options.forEach(option => {
      if (option.content) numberOfAnswer++
      if (option.isCorrect) correctAnswer++
    })

    if (numberOfAnswer < 2) {
      this.setState({
        errorMessage: 'Please add alteast two answers'
      })
      isInvalid = false
    }
    if (correctAnswer < 1) {
      this.setState({
        errorMessage: 'Please select minimum of one correct answer'
      })
      isInvalid = false
    }
    if (isInvalid) {
      this.setState({
        errorMessage: ''
      })
    }
    return isInvalid
  }

  saveStep = _ => {
    const {
      questionType,
      options,
      questionSelectType,
      content,
      chapter,
      selectedClassName,
      steps,
      stepIndex
    } = this.state
    const payload = {
      questionType,
      type: questionSelectType?.value,
      typeName: questionSelectType?.title,
      options: options.map(option => {
        return {
          isCorrect: option.isCorrect,
          content: option.content,
          contentType: 1,
          contentTypeName: 'TEXT'
        }
      }),
      content: content,
      chapterId: chapter?.value,
      class: selectedClassName
    }
    const isValid = this.validateStepPayload(payload)
    if (!isValid) return
    steps[stepIndex] = {
      type: payload?.type,
      typeName: payload?.typeName,
      options: payload.options,
      content: payload.content,
      mark: 5
    }
    this.setState({
      steps,
      onlyStep: false
    })
  }

  validatePayload = payload => {
    let isInvalid = true
    if (!payload.class) {
      this.setState({
        errorMessage: 'Please Select Class'
      })
      isInvalid = false
    }
    if (!payload.chapterId) {
      this.setState({
        errorMessage: 'Please Select Chapter'
      })
      isInvalid = false
    }
    if (!payload.questionType) {
      this.setState({
        errorMessage: 'Please Select Step'
      })
      isInvalid = false
    }
    if (payload.questionType.value === 1 && payload.steps.length < 1) {
      this.setState({
        errorMessage: 'Please add alteast one step'
      })
      isInvalid = false
    }
    if (payload.questionType.value === 2 && payload.steps.length < 2) {
      this.setState({
        errorMessage: 'Please add alteast two steps'
      })
      isInvalid = false
    }
    if (payload.questionType.value === 2 && !payload.questionContent) {
      this.setState({
        errorMessage: 'Please enter question'
      })
      isInvalid = false
    }

    payload.steps.forEach((step, index) => {
      if (!step.content) {
        this.setState({
          errorMessage: 'Please enter question'
        })
        isInvalid = false
      }
      if (!step.type || !step.typeName) {
        this.setState({
          errorMessage: 'Please select question type'
        })
        isInvalid = false
      }
      let numberOfAnswer = 0
      let correctAnswer = 0
      step.options.forEach(option => {
        if (option.content) numberOfAnswer++
        if (option.isCorrect) correctAnswer++
      })

      if (numberOfAnswer < 2) {
        this.setState({
          errorMessage: 'Please add alteast two answers'
        })
        isInvalid = false
      }
      if (correctAnswer < 1) {
        this.setState({
          errorMessage: 'Please select minimum of one correct answer'
        })
        isInvalid = false
      }
    })

    if (isInvalid === true) {
      this.setState({
        errorMessage: ''
      })
    }
    return isInvalid
  }

  getSingleSteps = _ => {
    const { options, content, questionSelectType } = this.state
    const steps = []
    steps.push({
      content: content,
      options: options.map(option => {
        return {
          isCorrect: option.isCorrect,
          content: option.content,
          contentType: 1,
          contentTypeName: 'TEXT'
        }
      }),
      type: questionSelectType.value,
      typeName: questionSelectType.title,
      mark: 5
    })
    return steps
  }

  saveQuestionSet = _ => {
    const {
      questionType,
      steps,
      chapter,
      selectedClassName,
      selectedQuestion,
      questionContent
    } = this.state
    const payload = {
      questionType,
      questionContent,
      isMultiStep: questionType?.value === 2 ? true : false,
      steps: questionType?.value === 2 ? steps : this.getSingleSteps(),
      chapterId: chapter?.value,
      class: selectedClassName
    }
    const isValid = this.validatePayload(payload)
    if (!isValid) return
    this.setState({
      isSubmit: true
    })
    if (selectedQuestion && selectedQuestion._id) {
      payload._id = selectedQuestion._id
      QuestionSetApi.updateQuestion(payload)
        .then(response => {
          this.setState(
            {
              isSubmit: false,
              showAddQuestion: false,
              selectedQuestion: null,
              steps: [DEFAULT_STEP_VALUE]
            },
            _ => {
              this.questionListRef.getQuestionSet({})
            }
          )
          this.showToaster('info', 'Question updated successfully')
        })
        .catch(err => {
          if (err?.response?.data?.code === 11000) {
            this.showToaster('info', 'Question set already added for chapter')
            this.setState({
              isSubmit: false
            })
          } else {
            this.setState({
              isSubmit: false
            })
          }
        })
    } else {
      QuestionSetApi.createQuestionSet(payload)
        .then(response => {
          this.setState(
            {
              isSubmit: false,
              showAddQuestion: false,
              selectedQuestion: null,
              content: '',
              options: [
                {
                  isCorrect: false,
                  content: ''
                },
                {
                  isCorrect: false,
                  content: ''
                },
                {
                  isCorrect: false,
                  content: ''
                },
                {
                  isCorrect: false,
                  content: ''
                }
              ],
              questionSelectType: {
                title: 'SINGLE SELECT',
                value: 1
              },
              questionType: {
                title: 'SINGLE STEP',
                value: 1
              }
            },
            _ => {
              this.questionListRef.getQuestionSet({})
            }
          )
          this.showToaster('info', 'Question Set Added Successfully')
        })
        .catch(err => {
          if (err?.response?.data?.code === 11000) {
            this.showToaster('info', 'Question set already added for chapter')
            this.setState({
              isSubmit: false
            })
          } else {
            this.setState({
              isSubmit: false
            })
          }
        })
    }
  }

  showToaster (type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster () {
    this.setState({
      showToaster: false
    })
  }

  onEdit = (chapter, className, question) => {
    this.setState(
      {
        chapter,
        selectedClassName: className,
        selectedQuestion: question
      },
      _ => {
        this.openAddQuestion()
        if (this.tooltip) {
          this.tooltip.tooltipRef = null
          this.tooltip.hideTooltip()
        }
        ReactTooltip.hide()
      }
    )
  }

  onOpenAddQuestion = (chapter, className) => {
    this.setState(
      {
        chapter,
        selectedClassName: className
      },
      _ => {
        this.openAddQuestion(true)
      }
    )
  }

  renderClassSelectionPopup = _ => {
    const {
      classes,
      selectedClassName,
      errorMessage,
      chapter,
      chapterList
    } = this.state
    return (
      <Modal
        className='cw-custom-modal question-bank-add'
        isOpen={true}
        toggle={this.hideSelectChapter}
        size={'md'}
      >
        <ModalBody>
          <div className='row'>
            <div className='col text-right'>
              <img
                className='close-icon cursor-pointer'
                onClick={this.hideSelectChapter}
                src={getImageSource(ImageConstants.CROSS)}
              />
            </div>
          </div>
          <div className='header-text text-center'>
            <span>Add new Question for</span>
          </div>
          <div className='px-2 mt-4'>
            <label>Class</label>
            <div className='row class-container'>
              {classes?.map((c, index) => (
                <div
                  key={index}
                  onClick={_ =>
                    this.onSelectNormal(c.title, 'selectedClassName')
                  }
                  className={`class-title cursor-pointer py-2 mr-4 ${selectedClassName ===
                    c.title && 'class-active'}`}
                >
                  {c.title}
                </div>
              ))}
            </div>
          </div>
          <div className='px-2 mt-4'>
            <label>Chapter</label>
            <div className='row class-container chapter-dropdown'>
              <Dropdown
                text='title'
                placeholder='Select Chapter'
                options={chapterList}
                onSelect={option => this.onSelectNormal(option, 'chapter')}
                value={chapter?.value}
                style={{ background: '#F6F7F5' }}
              />
            </div>
          </div>
          <div className='text-center mt-4'>
            {errorMessage && (
              <div className='text-danger pb-4'>
                <strong>{errorMessage} </strong>
              </div>
            )}
            <button
              className={`cw-button-primary ${
                !selectedClassName || !chapter?.value
                  ? 'cw-button-disabled'
                  : ''
              }`}
              onClick={_ => this.openAddQuestion(true)}
            >
              Continue
            </button>
          </div>
        </ModalBody>
      </Modal>
    )
  }

  render () {
    const {
      search,
      toasterMessage,
      toasterType,
      showAddQuestion,
      showSelectChapter,
      showToaster,
      selectedTabName,
      selectedClassName,
      chapter,
      selectedQuestion
    } = this.state
    return (
      <div className='question-bank'>
        {/* <div
          className='mb-5 cursor-pointer'
          onClick={_ =>
            this.props.history.push({ pathname: Path.STANDARD_HOMEWORK, showList: true })
          }
        >
          <img
            className='ad-banner'
            src={getImageSource(ImageConstants.AD_BANNER_1)}
          />
        </div> */}
        <div className='header-container'>
          <span className='screen-title d-inline-block'>My Question Bank</span>
          <span className='float-right d-inline-block'>
            <button
              className={`cw-button-primary`}
              onClick={this.openSelectChapter}
            >
              ADD NEW QUESTION
            </button>
          </span>
        </div>
        <div>{this.getTabs()}</div>
        <div className='pt-1'>
          {selectedTabName && (
            <QuestionList
              ref={el => (this.questionListRef = el)}
              className={selectedTabName}
              onEdit={this.onEdit}
              onPageSelected={this.onPageSelected}
              onOpenAddQuestion={this.onOpenAddQuestion}
              {...this.props}
            />
          )}
        </div>
        {showSelectChapter && this.renderClassSelectionPopup()}
        {showAddQuestion && (
          <AddQuestion
            ref={el => (this.addQuestionRef = el)}
            className={selectedClassName}
            chapter={chapter}
            question={selectedQuestion}
            hideAddQuestion={this.hideAddQuestion}
            addQuestionsSuccess={this.addQuestionsSuccess}
          />
        )}
        {showToaster ? (
          <div className='custom-toaster-modal'>
            {' '}
            <ToasterComponent
              message={toasterMessage}
              type={toasterType}
              position='bottom-center'
            />{' '}
          </div>
        ) : (
          ''
        )}
        <ReactTooltip
          ref={el => (this.tooltip = el)}
          multiline={true}
          place='bottom'
          type='dark'
          effect='solid'
          event='mouseover mouseenter'
          eventOff='mouseleave mouseout scroll mousewheel blur'
        />
      </div>
    )
  }
}

export default QuestionBank
